"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIERED = exports.FLAT = void 0;
var FLAT = 'FLAT';
exports.FLAT = FLAT;
var TIERED = 'TIERED';
exports.TIERED = TIERED;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/PricingTypes.js
// module id = 421
// module chunks = 5 6 7